export default __webpack_public_path__ + "assets/7a341a28bc67e6f4ec1bdac27b438f70.png";